// moms-harness:anchor v2
// JIRA: LOGISPRD-13833, LOGISPRD-13840
import { PRICE_SCALE } from './consts'

/** `DECIMAL(10,2)` 의 정수부 자릿수. `PRICE_MAX`(99,999,999.99)의 정수부와 같다. */
const PRICE_INT_DIGITS = 8

/**
 * 단가 셀 입력 중의 텍스트 정리 — **숫자·소수점 하나만 남기고 자릿수를 컬럼 폭에 맞춘다.**
 *
 * ### 왜 pbo-core `amountInput` 을 쓰지 않는가
 *
 * 그 셀은 세 가지로 이 화면의 단가를 받을 수 없다 (pbo-core 0.8.2 실측).
 *
 * 1. 값이 `null` 이면 입력칸 대신 `"-"` 만 그린다 — **'+추가' 행은 단가가 `null` 로 시작해 입력이 불가능했다**
 * 2. `[^0-9]` 를 지워 **소수점을 받지 않는다** — 컬럼은 소수 2자리다
 * 3. 기본 최대 5자리라 **100,000 이상을 받지 않는다** — 컬럼 정수부는 8자리다
 *
 * ### 여기서 자르는 것과 `validateRow` 가 거르는 것
 *
 * 이 함수는 **입력 중 형태**만 다듬는다(자릿수 초과 타이핑이 들어가지 않게). 값의 범위 판정은
 * 저장 전 `validateRow` 가 한다 — 엑셀 경로는 이 함수를 거치지 않으므로 거기서 한 번 더 막아야 한다.
 *
 * `"12."` 처럼 **끝이 소수점인 중간 상태를 그대로 둔다.** 지우면 소수를 칠 수 없다. 반대로 정수부가
 * 비면(`.5`) `0` 을 채워 `0.5` 로 보인다 — 값은 같고 표기만 자연스럽게 한다.
 */
export const sanitizePriceText = (raw: string): string => {
  // 천단위 콤마는 사람이 붙여 넣는 표기다 — 숫자 외 문자와 함께 걷어낸다
  const cleaned = raw.replaceAll(/[^0-9.]/g, '')
  const dot = cleaned.indexOf('.')
  if (dot < 0) return cleaned.slice(0, PRICE_INT_DIGITS)

  const intPart = cleaned.slice(0, Math.min(dot, PRICE_INT_DIGITS)) || '0'
  // 두 번째 이후의 소수점은 버린다 — `1.2.3` 은 `1.23` 이 된다
  const fracPart = cleaned
    .slice(dot + 1)
    .replaceAll('.', '')
    .slice(0, PRICE_SCALE)
  return `${intPart}.${fracPart}`
}

/** 행 값(`number | null`) → 셀 표시 텍스트. `null` 은 빈 칸이다 — `"-"` 가 아니다. */
export const priceToText = (value: number | null | undefined): string => (value == null ? '' : String(value))
